// Enums do domínio. Fonte única: o back usa nos CHECKs/colunas e o front nos rótulos.
export const USER_ROLES = ['cliente', 'tecnico', 'administrador'];
export const TICKET_STATUS = [
    'aberto',
    'em_atendimento',
    'aguardando_cliente',
    'aguardando_terceiros',
    'encerrado',
    'cancelado',
];
/** Status em que o chamado ainda está em andamento. */
export const STATUS_ABERTOS = [
    'aberto',
    'em_atendimento',
    'aguardando_cliente',
    'aguardando_terceiros',
];
/** Status que ocupam capacidade do técnico (ver 5.19). */
export const STATUS_OCUPA_CAPACIDADE = [
    'em_atendimento',
    'aguardando_terceiros',
];
export const PRIORITIES = ['baixa', 'media', 'alta'];
export const PRIORITY_LABEL = {
    baixa: 'Baixa',
    media: 'Média',
    alta: 'Alta',
};
export const TICKET_TYPE_LABEL = {
    incidente: 'Incidente',
    requisicao: 'Requisição',
    duvida: 'Dúvida',
    melhoria: 'Melhoria',
};
export const TICKET_TYPES = ['incidente', 'requisicao', 'duvida', 'melhoria'];
export const TICKET_CHANNELS = ['portal', 'agente'];
export const CLOSE_REASONS = [
    'resolvido',
    'sem_retorno',
    'duplicado',
    'cancelado_pelo_cliente',
];
export const DISTRIBUTION_MODES = ['fila', 'rodizio', 'menor_carga'];
/** No assunto, 'herdar' usa o modo da área. */
export const SUBJECT_DISTRIBUTION = ['herdar', ...DISTRIBUTION_MODES];
export const PROJECT_STATUS = [
    'em_implantacao',
    'em_producao',
    'pausado',
    'encerrado',
];
/** Projetos em que ainda se pode abrir chamado (ver 5.20). */
export const PROJECT_STATUS_ABERTURA = [
    'em_implantacao',
    'em_producao',
];
export const MESSAGE_KINDS = ['resposta', 'nota_interna', 'sistema'];
export const ACTIVITY_KINDS = ['analise', 'contato', 'ajuste', 'escalonamento'];
export const SURVEY_RESOLVED = ['sim', 'em_parte', 'nao'];
export const SLA_UNITS = ['minutos', 'horas', 'dias_uteis'];
export const HOLIDAY_KINDS = ['nacional', 'estadual', 'municipal', 'empresa'];
